import { createSlice } from "@reduxjs/toolkit";
import { v4 as uuid } from "uuid";

const initialState = {
  // Estados
  filaAssinaturaStateKey: uuid(),

  // Eventos
  filaAssinaturaSucessoStateKey: null,
  filaAssinaturaFalhaStateKey: null,
  assinaturaRequisitadaStateKey: null,
};

/**
 * Recurso que deve ser utilizado para atualizar qualquer estado
 * local da aplicação via SignalR.
 *
 * Mudanças de estado remoto devem alterar o uuid da chave local
 * para provocar a atualização nos ouvintes interessados.
 *
 * Mesmo objetos complexos podem ser usados como um StateKey
 * porque terão diferentes endereços de memória. Isso quer dizer
 * que ele cumpre ao mesmo tempo papel também de payload se for
 * necessário.
 *
 */
const signalrSlice = createSlice({
  name: "signalr",
  initialState,
  reducers: {
    remoteStateChanged(state, action) {
      const newStateKey = uuid();
      state[`${action.payload.stateKey}StateKey`] = action.payload.data ?? newStateKey;

      // eslint-disable-next-line no-console
      console.info(
        `Novo estado/evento "${action.payload.stateKey}" sinalizado. State Key:`,
        state[`${action.payload.stateKey}StateKey`],
      );
    },
    clearState(state, action) {
      state[action.payload] = null;
    },
  },
});

export const signalrActions = signalrSlice.actions;

export default signalrSlice.reducer;
